const getters = {
  getAnswers(store) {
    return store.answers;
  },
  getQuestionOrder(store) {
    return store.questionOrder ? store.questionOrder.reverse() : null;
  },
};

export default getters;
